import { render, staticRenderFns } from "./fixdList.vue?vue&type=template&id=23909d7a&"
import script from "./fixdList.vue?vue&type=script&lang=js&"
export * from "./fixdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports